import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { Typography } from '@tkww/the-bash-frontend';
import { useTheme } from '@mui/material/styles';

import { MARKET_TILE_IMAGES } from 'constants/Venues';
import SectionContainer from 'components/grid/SectionContainer';
import EditorialContainer from 'components/grid/EditorialContainer';

import MarketTile from './MarketTile';
import VenueMarket from './VenueMarket';

const AllVenuesPage = ({ activeMarkets }) => {
  const theme = useTheme();

  return (
    <>
      <EditorialContainer backgroundColor={theme.palette.grey['200']} justifyContent="center">
        <Typography variant="h1" align="center">
          Explore Venue By Cities
        </Typography>
        <Typography variant="body1" component="h2" align="center">
          Looking for an event venue for your next celebration? From small party venues in Chicago
          to outdoor event venues in Los Angeles, you can find the perfect party venue for every
          occasion on The Bash.
        </Typography>
      </EditorialContainer>
      <SectionContainer
        sx={{
          paddingBottom: 4,
        }}
        backgroundColor={theme.palette.grey['200']}
      >
        <Grid container pt={7} data-testid="marketTilesSection">
          {activeMarkets.map((market) => (
            <MarketTile
              market={market}
              key={market.fileName}
              marketImage={MARKET_TILE_IMAGES[market.fileName]}
            />
          ))}
        </Grid>
      </SectionContainer>
      <SectionContainer>
        <div data-testid="venueMarketsSection">
          {activeMarkets.map((market, index) => (
            <VenueMarket
              market={market}
              index={index}
              key={market.fileName}
              marketImage={MARKET_TILE_IMAGES[market.fileName]}
            />
          ))}
        </div>
      </SectionContainer>
    </>
  );
};

AllVenuesPage.propTypes = {
  activeMarkets: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      displayName: PropTypes.string.isRequired,
      fileName: PropTypes.string.isRequired,
      crawlableVenueTypes: PropTypes.arrayOf(
        PropTypes.shape({
          displayName: PropTypes.string.isRequired,
          fileName: PropTypes.string.isRequired,
          serviceId: PropTypes.number.isRequired,
        })
      ).isRequired,
    })
  ),
};

export default AllVenuesPage;
